

















































import Vue from 'vue';
import mixins from '@/utils/mixins';
import events from '@/mixins/events';
import app from '@/mixins/app';
export default mixins(Vue, app, events).extend({
  props: {
    title: { type: String, default: null },
    icon: { type: String, default: null },
    color: { type: String, default: 'primary' },
    text: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  methods: {
    toggle: function() {
      this.eventDialog = true;
    }
  },
  data() {
    return {
      items: [
        { title: 'See all events', route: true, action: { name: 'select' } },
        {
          title: 'Add Event',
          action: this.TOGGLE_EVENT_DIALOG
        },
        { divider: true },
        { header: 'All Events' },
        {
          title: this.title,
          route: true,
          action: { name: 'event-detail', params: { id: this.getCurrentEvent } }
        }
      ]
    };
  }
});
